import React from 'react';
import './style.scss';
import { Collapsable } from '@fiverr/fit';
import sections from './sections.json';

const CollapsableLists = ({categories}) => (
    <div className="collapsable-lists">
        <Collapsable group="footer-group">
            {() => (
                <h4>
                    {i18n.t('footer.categories')}
                </h4>
            )}
            {() => (
                <ul>
                    {categories.map((category, index) => (
                        <li key={index}>
                            <a href={category.url}>{category.name}</a>
                        </li>
                    ))}
                </ul>
            )}
        </Collapsable>
        <div className="footer-columns">
            {sections.sectionsArr.map((section, index) =>
                (<Collapsable key={index} group="footer-group">
                    {() => (
                        <h4>
                            {i18n.t(`footer.sections.${section.key}`)}
                        </h4>
                    )}
                    {() => (
                        <ul>
                            {section.values.map((link) => (
                                <li key={link.key}>
                                    <a href={`${link.url}${link.external ? '' : addSourceParam(link.url)}`} target={link.external ? '_blank' : null}>{i18n.t(`footer.sections.${link.key}`)}
                                        {link.subTitle && <small>{i18n.t(`footer.sections.${link.subTitle}`)}</small>}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    )}
                </Collapsable>)
            )}
        </div>
    </div>
);

const addSourceParam = (url) => {
    const footerSource = 'source=footer';
    return url.includes('?') ? `&${footerSource}` : `?${footerSource}`;
};

export default CollapsableLists;



// WEBPACK FOOTER //
// ./src/components/CollapsableLists/index.js